/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\VW.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:26:32 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function VW(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M545.26,805.83c-145.68,0-265.03-119.93-265.03-265.61,0-32.76,5.85-63.77,16.97-93.02l155.04,311.83c1.76,4.1,4.68,7.61,9.36,7.61s7.61-3.51,9.36-7.61l71.38-159.72c.59-1.76,1.76-3.51,3.51-3.51s2.34,1.76,3.51,3.51l71.38,159.72c1.76,4.1,4.68,7.61,9.36,7.61s7.61-3.51,9.36-7.61l155.04-311.83c11.12,29.25,16.97,60.26,16.97,93.02-1.17,145.68-120.52,265.61-266.2,265.61h0Zm0-325.87c-1.76,0-2.34-1.76-3.51-3.51l-83.08-187.21c26.91-9.95,56.16-15.21,86.59-15.21s59.67,5.27,86.59,15.21l-83.08,187.21c-1.17,2.34-1.76,3.51-3.51,3.51h0Zm-84.83,192.48c-1.76,0-2.34-1.76-3.51-3.51l-134.56-271.46c23.99-36.86,56.16-67.87,95.36-89.51l97.12,215.88c1.17,3.51,4.1,4.68,7.02,4.68h46.8c3.51,0,5.85-.59,7.61-4.68l97.12-215.88c38.61,21.65,71.38,52.65,95.36,89.51l-135.73,271.46c-.59,1.76-1.76,3.51-3.51,3.51s-2.34-1.76-3.51-3.51l-50.9-115.84c-1.76-4.1-4.1-4.68-7.61-4.68h-46.8c-3.51,0-5.85,.59-7.61,4.68l-49.14,115.84c-.59,1.76-1.76,3.51-3.51,3.51Zm84.83,160.3c162.06,0,292.52-130.47,292.52-292.52s-130.47-292.52-292.52-292.52S252.74,378.16,252.74,540.21s130.47,292.52,292.52,292.52Z"/>
        </svg>
    );
}

export default VW;
